import { FC, useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { ScenarioKPI } from "../ScenarioKPI/ScenarioKPI";
import './entregaslayout.css'



export const EntregasLayout:FC<any> = (props):JSX.Element => {

  const { comparativa, state, kpis, filtered } = props

  const [estado, setEstado] = useState<any>(state)

    return (
        <div className="entregas-layout__wrapper">
            <div style={{height:'25%',display:'flex',justifyContent:'space-around',alignItems:'center',width:'100%'}}>
                {
                    kpis.map((kpi:any) => {
                        return (
                            <ScenarioKPI
                                title={kpi.title}
                                kpiB={kpi.kpiB}
                                kpiC={kpi.kpiC}
                                comparativa={comparativa}
                                filtered={filtered}
                            />
                        )
                    })
                }
                
                
            </div>
            <div style={{height:'70%',width:'100%'}} className="bar-overflow">
                <ReactApexChart options={estado.options} series={estado.series.map((s:any) => ({...s,data:s.data.map((d:any) => {if(d === 0) {
                    return 0.000001
                }
                return d
                })
                }))} type="bar" height={'100%'} />
            </div>
            {/*<EnviosTable />*/}
        </div>
    )
}